var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#848484;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#9A9999;}\n\t.st4{fill:#CDCCCC;}\n\t.st5{fill:#313131;}\n\t.st6{fill:#FABC99;}\n\t.st7{fill:#E2A181;}\n\t.st8{fill:#D96E82;}\n\t.st9{fill:#27150E;}\n\t.st10{fill:#DDDDDC;}\n\t.st11{fill:#E8E8E8;}\n\t.st12{opacity:0.4;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evidencia_de_video",
    transform: "translate(16845 -1652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12106",
    className: "st0",
    d: "M-16845,1652h130v130h-130V1652z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2641",
    transform: "translate(-17384.891 248.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2608",
    transform: "translate(543.836 1437.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1683",
    transform: "translate(0 62.221) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1682",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selfie",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5709",
    className: "st1",
    d: "M1.9,63.3C2.2,64.2,2.6,65.1,3,66c0.2,0.4,0.4,0.7,0.5,1.1c0.3,0.5,0.5,1,0.7,1.5v-5.2 C3.5,63.4,2.7,63.4,1.9,63.3z M53,0H9.3C4,0.2-0.2,4.6,0,9.8v102.5c0,0.2,0,0.3,0,0.5v0.1c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.1,0,0.2v0c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.3 c0,0.1,0.1,0.3,0.1,0.4s0.1,0.2,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.4,1,0.7,1.4 c0.1,0.2,0.3,0.5,0.5,0.7c0.3,0.5,0.7,0.9,1.1,1.3c0.1,0.1,0.2,0.2,0.3,0.3s0.2,0.2,0.3,0.3c0.2,0.2,0.4,0.3,0.6,0.4 c0.1,0.1,0.2,0.1,0.3,0.2s0.2,0.1,0.3,0.2s0.2,0.1,0.3,0.2s0.2,0.1,0.4,0.2c0,0,0,0,0.1,0c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.3,0.1,0.4,0.1 c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.6,0,0.9,0h43.7c5-0.1,9-4.1,9.3-9.1c0-0.1,0-0.2,0-0.2l0,0c0-0.2,0-0.3,0-0.5V9.8 C62.4,4.6,58.3,0.2,53,0C53,0,53,0,53,0z M58,106.4H4.3V15.7H58L58,106.4L58,106.4z M1.9,63.3C2.2,64.2,2.6,65.1,3,66 c0.2,0.4,0.4,0.7,0.5,1.1c0.3,0.5,0.5,1,0.7,1.5v-5.2C3.5,63.4,2.7,63.4,1.9,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7127",
    className: "st2",
    d: "M1.8,15.7h59.1v90.7H1.8V15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5712",
    className: "st3",
    d: "M52.4,8c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4 C51.3,5.6,52.4,6.7,52.4,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5732",
    className: "st4",
    d: "M42.4,8c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0h-20c-0.6,0-1.1-0.5-1.1-1.1l0,0 c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0h20C41.9,6.9,42.4,7.4,42.4,8C42.4,8,42.4,8,42.4,8L42.4,8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1640",
    transform: "translate(58.425 43.585) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2395",
    x: 2.5,
    y: 28,
    className: "st5",
    width: 30.8,
    height: 25.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2396",
    x: 13.9,
    y: 39.7,
    className: "st6",
    width: 7.1,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5740",
    className: "st7",
    d: "M19.5,41.7c0.5,0,1,0.1,1.5,0.2v-2.2h-7.1v5.8C14.7,43.1,17,41.6,19.5,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5741",
    className: "st6",
    d: "M20.5,44.8h-6.1c0,0-12.1-0.7-14.4,11.9h34.9C32.6,44.1,20.5,44.8,20.5,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5742",
    className: "st6",
    d: "M32,22.6c0,10.3-6,18.6-14.5,18.6S2.9,32.8,2.9,22.6S9,3.9,17.5,3.9S32,12.3,32,22.6z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1634",
    transform: "translate(30.074 24.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5743",
    className: "st6",
    d: "M0.1,2.6c-0.3,1.6,0.3,3.1,1.3,3.3s2.1-1,2.4-2.6S3.5,0.2,2.5,0S0.4,1,0.1,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5744",
    className: "st7",
    d: "M1.9,1.6c0,0,0.1,0,0.2,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2 C2.5,2,2.6,2.1,2.6,2.2c0,0.1,0,0.2,0.1,0.3c0,0.2,0,0.5-0.1,0.7c0,0.2-0.1,0.5-0.2,0.7C2.3,4.1,2.2,4.2,2,4.4 C2,4.4,1.9,4.5,1.8,4.5c-0.1,0-0.1,0.1-0.2,0c-0.1,0-0.2,0-0.2,0c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.3,0.1 c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.5-0.3,0.6-0.6C3,3.9,3.1,3.6,3.2,3.3c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3-0.1-0.5 c0-0.2-0.1-0.3-0.2-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1C2.6,1.6,2.5,1.6,2.4,1.5c-0.1,0-0.2,0-0.2,0 C2,1.6,2,1.6,1.9,1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1635",
    transform: "translate(1.012 24.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5745",
    className: "st6",
    d: "M3.8,2.6c0.3,1.6-0.3,3.1-1.3,3.3s-2.1-1-2.4-2.6S0.4,0.2,1.4,0S3.5,1,3.8,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5746",
    className: "st7",
    d: "M1.9,1.6c0,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0.1C1.5,1.8,1.4,1.9,1.4,1.9 C1.3,2,1.3,2.1,1.3,2.2c0,0.1,0,0.2-0.1,0.3c0,0.2,0,0.5,0.1,0.7c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.3,0.5 C1.9,4.4,1.9,4.5,2,4.5c0.1,0,0.1,0.1,0.2,0c0.1,0,0.2,0,0.2,0c0,0.1-0.1,0.1-0.2,0.1C2.2,4.7,2.1,4.7,2,4.8 c-0.1,0-0.2,0-0.3-0.1C1.4,4.6,1.2,4.4,1,4.1C0.8,3.9,0.7,3.6,0.7,3.3c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0.1-0.5 c0-0.2,0.1-0.3,0.2-0.4c0-0.1,0.1-0.1,0.1-0.2l0.2-0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0C1.8,1.6,1.9,1.6,1.9,1.6z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5747",
    className: "st8",
    d: "M29.6,56.7H6.3c4.1-3.1,1.1-10.4,1.1-10.4c0.8-0.4,1.6-0.7,2.5-0.9 c0,0,7.6,9.3,15.1,0c1.1,0.3,2.2,0.7,3.2,1.3C28.2,46.7,24,53.6,29.6,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5748",
    className: "st9",
    d: "M2.9,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5749",
    className: "st9",
    d: "M11,4.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1637",
    transform: "translate(2.122 28.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5750",
    className: "st10",
    d: "M2,1c0,0.5-0.4,1-1,1C0.4,2,0,1.5,0,1c0-0.5,0.4-1,1-1C1.5,0,2,0.4,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5751",
    className: "st11",
    d: "M1.9,1.3c-0.3,0.3-0.8,0.3-1.1,0C0.6,1.2,0.6,1,0.6,0.8v0c0-0.3,0.2-0.6,0.6-0.7 C1.1,0,1,0,1,0C0.4,0,0,0.4,0,1s0.4,1,1,1C1.4,2,1.8,1.7,1.9,1.3C1.9,1.3,1.9,1.3,1.9,1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5752",
    className: "st2",
    d: "M1.7,0.7c0,0.2-0.2,0.4-0.4,0.4C1.1,1.1,1,0.9,1,0.7c0-0.2,0.2-0.4,0.4-0.4 C1.5,0.3,1.7,0.5,1.7,0.7C1.7,0.7,1.7,0.7,1.7,0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1639",
    transform: "translate(30.555 28.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5753",
    className: "st10",
    d: "M2,1c0,0.5-0.4,1-1,1C0.4,2,0,1.5,0,1s0.4-1,1-1C1.5,0,2,0.4,2,1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5754",
    className: "st11",
    d: "M1.9,1.3c-0.3,0.3-0.8,0.3-1.1,0C0.6,1.2,0.6,1,0.6,0.8v0c0-0.3,0.2-0.6,0.6-0.7 C1.1,0,1,0,1,0C0.4,0,0,0.4,0,1s0.4,1,1,1C1.4,2,1.8,1.7,1.9,1.3C1.9,1.3,1.9,1.3,1.9,1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5755",
    className: "st2",
    d: "M1.7,0.7c0,0.2-0.2,0.4-0.4,0.4S1,0.9,1,0.7c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0 C1.5,0.3,1.7,0.5,1.7,0.7C1.7,0.7,1.7,0.7,1.7,0.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5756",
    className: "st5",
    d: "M16.2,6.1c0,0,2.2,7.9,14.1,12.3c0,0,1.5,1.2,1.3,6.5c0,0,0.6-1.3,1.7,0 c0,0,2.3-12.2-1.9-18.9c0,0-5.1-7.1-13.6-6C17.9,0.1,15.1,1.6,16.2,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5757",
    className: "st5",
    d: "M18.8,6.1c0,0-2.2,7.9-14.1,12.3c0,0-1.5,1.2-1.3,6.5c0,0-0.6-1.3-1.7,0 c0,0-2.3-12.2,1.9-18.9c0,0,5.1-7.1,13.6-6C17.1,0.1,20,1.6,18.8,6.1z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1398",
    transform: "translate(596.035 1463.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_4436"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M8.9,17.2c-4.6,0-8.4-3.7-8.4-8.4s3.7-8.4,8.4-8.4s8.4,3.7,8.4,8.4S13.5,17.2,8.9,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.9,1C4.5,1,1,4.5,1,8.9s3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9S13.2,1,8.9,1 M8.9,0c4.9,0,8.9,4,8.9,8.9 s-4,8.9-8.9,8.9S0,13.7,0,8.9S4,0,8.9,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Componente_1852_8",
    transform: "translate(5.481 5.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4435",
    className: "st0",
    d: "M0,0h7.5v7.5H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4434",
    className: "st2",
    d: "M6.3,2.8c0.6,0.3,0.8,1.1,0.5,1.7C6.6,4.7,6.5,4.9,6.3,5L2,7.4C1.3,7.7,0.5,7.5,0.2,6.9 C0.1,6.7,0,6.5,0,6.3V1.5c0-0.7,0.6-1.3,1.4-1.3c0.2,0,0.4,0.1,0.6,0.2L6.3,2.8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvVideo);
export default __webpack_public_path__ + "static/media/evVideo.0e5bde5f23f5b3d2d44a67fe31d42c6d.svg";
export { ForwardRef as ReactComponent };